export const transitionDuration = 0.2;
export const transitionIn = { duration: transitionDuration, ease: 'easeIn' };
export const transitionOut = { duration: transitionDuration, ease: 'easeOut' };
